import { useContext, useEffect } from 'react';
import { TooltipContext } from './tooltipContext';
import { useSearchContext } from 'Guide/Schematics/Diagram/Providers/searchContext';
import { iFixitHotSpotItem } from '../Generic/iFixitHotSpotItem';

const getHotspotIdFromRoute = () => {
   const hash = window.location.hash;
   const matches = hash.match(/hotspot\/([\d-]+)/);
   let routeIdToOpen = null;
   if (matches && matches.length > 1) {
      routeIdToOpen = matches[1];
   }
   return routeIdToOpen;
};

const getRouteHash = (
   diagramid: string | number | null,
   dataPointId: string | null,
   searchText: string | null
) => {
   if (!diagramid) {
      return '';
   }

   let hash = `diagram/${diagramid}`;

   if (dataPointId) {
      hash += `/hotspot/${dataPointId}`;
   }

   if (searchText) {
      hash += `/search/${searchText}`;
   }

   return hash;
};

function updateHash({
   isOpen,
   diagramid,
   dataPointId,
   searchText,
}: {
   isOpen: boolean;
   diagramid?: string | number;
   dataPointId?: string;
   searchText?: string;
}) {
   const routeDiagramid = isOpen ? diagramid : null;
   // @ts-expect-error TS(2345) FIXME: Argument of type 'string | number | null | undefin... Remove this comment to see the full error message
   const hash = getRouteHash(routeDiagramid, dataPointId, searchText);
   const url = new URL(window.location.href);
   url.hash = hash;
   // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
   history.replaceState(null, null, url.href);
}

export function DiagramHash({
   diagramid,
   isOpen,
}: {
   diagramid: string | number;
   isOpen: boolean;
}) {
   const tooltipContext = useContext(TooltipContext);
   const searchContext = useSearchContext<iFixitHotSpotItem>();

   const dataPointId = tooltipContext.openDataPointId;
   const searchText = searchContext.searchText;

   useEffect(() => {
      // @ts-expect-error TS(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
      updateHash({ isOpen, diagramid, dataPointId, searchText });
      return () => {
         updateHash({ isOpen: false });
      };
   }, [dataPointId, isOpen, searchText, diagramid]);

   return <></>;
}

const getSearchString = () => {
   const hash = window.location.hash;
   const matches = hash.match(/\/search\/([^/]*)/);
   let searchText = '';
   if (matches && matches.length > 1) {
      searchText = matches[1];
   }
   return decodeURI(searchText);
};

const getDiagramIdFromRoute = () => {
   const hash = window.location.hash;
   const matches = hash.match(/diagram\/([^/]*)/);
   let diagramid = '';
   if (matches && matches.length > 1) {
      diagramid = matches[1];
   }
   return diagramid;
};

export function getHashParts() {
   return {
      hashDiagramid: getDiagramIdFromRoute(),
      hashHotspotId: getHotspotIdFromRoute(),
      hashSearchText: getSearchString(),
   };
}
